import { Component, Vue, Prop, Ref } from "vue-property-decorator";
import R from "ramda";
import { noop, stopPropagation } from "@/components/RenderUtils/utils";
import getLang from "@/components/RenderUtils/utils/lang";
import getStyles from "@/components/RenderUtils/utils/style";
import "../style/workstationSetting.less";
import ProductInfo from "./productInfo";
import TransportDirectory from "./transportDirectory";
import AssociatedIots from "./associatedIots";
import ParameterSetting from "./parameterSetting";
import RemoteConnectionConfig from "./remoteConnectionConfig";
import { ACLS } from "@/components/RenderUtils/utils/constants";

@Component({
  ProductInfo,
  ParameterSetting,
  AssociatedIots,
  TransportDirectory,
  RemoteConnectionConfig,
})
export default class WorkstationSetting extends Vue {
  @Ref() readonly iotRef!: AssociatedIots;
  @Prop({ default: () => {} }) readonly productInfo: Object;
  @Prop({ default: () => [] }) readonly parameterSetting: Array<any>;
  @Prop({ default: () => [] }) readonly associatedIot: Array<any>;
  @Prop() readonly workstationId: any;
  @Prop() readonly workstation: any;
  @Prop({ default: () => "edit" }) readonly type: string;

  activePanel = ["0"];

  get lang() {
    return getLang(this);
  }

  render() {
    return (
      <div>
        {this.type === "edit" ? this.renderProductInfo() : null}
        {this.type === "edit"
          ? this.renderParameterSetting()
          : this.renderCollapse()}
        {this.type === "edit"
          ? this.renderCollapse()
          : this.renderParameterSetting()}
      </div>
    );
  }

  renderCollapse() {
    const renderHeader = (title) => (
      <span style={getStyles("pHeader")} slot="header">
        {title}
      </span>
    );
    const collapses = [
      {
        header: renderHeader(this.lang.associated_iot),
        render: this.renderAssociatedIots,
        renderExtra: () => (
          <span  slot="extra">
            <a-button
              size="small"
              type="link"
              onClick={($event)=>this.openAddIotDialog($event, false)}
              v-acl={ACLS.ADD_RELATE}
            >
              {this.lang.associate_old}
            </a-button>
            <a-divider type="vertical" v-acl={ACLS.ADD_RELATE} />
            <a-button
              size="small"
              type="link"
              onClick={($event)=>this.openAddIotDialog($event, true)}
              v-acl={ACLS.ADD_RELATE}
            >
              {this.lang.associate_new}
            </a-button>
          </span>
        )
      },
      {
        header: renderHeader(this.lang.transport_directory),
        render: this.renderTransportDirectory,
      },
      // {
      // header: renderHeader(this.lang.remoteConnectionConfig),
      //   render: () => this.renderRemoteConnectionConfig(),
      // },
    ];

    const mapper = ({ header, render, renderExtra = noop }, index) => (
      <a-collapse-panel
        key={R.toString(index)}
        style={getStyles("collapsePanel")}
        forceRender={true}
        class="workstation-collapse"
      >
        {header}
        {render()}
        {this.activePanel.includes(index.toString()) && renderExtra()}
      </a-collapse-panel>
    );

    const mapIndexed = R.addIndex(R.map);

    return (
      <div>
        <a-collapse
          v-model={this.activePanel}
          bordered={false}
          accordion={false}
          expandIconPosition="right"
          style={getStyles("collapse")}
        >
          {mapIndexed(mapper)(collapses)}
        </a-collapse>
      </div>
    );
  }
  //生产工位信息
  renderProductInfo() {
    return <ProductInfo   sourceData={this.productInfo} />;
  }
  //工况参数设定
  renderParameterSetting() {
    return (
      <ParameterSetting
        sourceData={this.parameterSetting}
        workstationId={this.workstationId}
        workstation={this.workstation}
      />
    );
  }
  //关联的IoT设备
  renderAssociatedIots() {
    return (
      <AssociatedIots
        ref="iotRef"
        sourceData={this.associatedIot}
        key={Date.now()}
        workstationId={this.workstationId}
        workstation={this.workstation}
      />
    );
  }
  //工位文件
  renderTransportDirectory() {
    return <TransportDirectory workstationId={this.workstationId} />;
  }
  //远程连接配置
  renderRemoteConnectionConfig() {
    return <RemoteConnectionConfig />;
  }
  openAddIotDialog(e, type) {
    stopPropagation(e);
    this.iotRef.addIot(type);
  }
}
